<script>
import { computed } from 'vue'
import Alert from '@/components/Alert'
import { clientData } from '@/stores/clientData'

export default {
  components: {
    Alert,
  },
  setup() {
    const originalMessage = window.shop_basket.bank_response_message
    const responseMessage = computed(() => {
      if (clientData.value && clientData.value.email) {
        return originalMessage.replace(/{email}/g, clientData.value.email)
      }
      return originalMessage.replace(/{email}/g, '')
    })

    return {
      responseMessage,
    }
  },
}
</script>

<template>
  <Alert v-html="responseMessage" v-if="responseMessage"></Alert>
</template>
